module.exports = __webpack_public_path__ + "img/exclamation-octagon.d4ecbfe3.svg";